"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
function isArgsImmutable(args) {
    var keys = Object.keys(args);
    return keys.every(function (key) { return immutable_1.isCollection(args[key]) || immutable_1.Record.isRecord(args[key]); });
}
exports.default = isArgsImmutable;
//# sourceMappingURL=isArgsImmutable.js.map